"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _SliderLabel = require("../SliderLabel/SliderLabel");
var _SliderThumb = require("../SliderThumb/SliderThumb");
var _SliderTrack = require("../SliderTrack/SliderTrack");
var _Slider = require("./Slider.styles");
var _excluded = ["id"];
/**
 * A custom slider component built on top of
 * [`react-slider`](https://github.com/zillow/react-slider)
 * (see the [example page](https://zillow.github.io/react-slider/)
 * for full props documentation).
 *
 * @since 6.12.0
 */
var Slider = function Slider(_ref) {
  var id = _ref.id,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Slider.StyledSlider, (0, _extends2.default)({
    id: id,
    thumbClassName: id + "-thumb"
  }, props));
};
exports.Slider = Slider;
Slider.displayName = 'Slider';
Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The id of the slider. This is also used to generate ids and classNames for
   * accessibility purposes.
   */
  id: _propTypes.default.string.isRequired,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  min: _propTypes.default.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  max: _propTypes.default.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  step: _propTypes.default.number,
  /**
   * Inherited from [`react-slider`](https://zillow.github.io/react-slider/)
   */
  onChange: _propTypes.default.func,
  /** @ignore */
  renderThumb: _propTypes.default.func,
  /** @ignore */
  renderTrack: _propTypes.default.func,
  /** @ignore */
  pearling: _propTypes.default.bool
} : {};
Slider.defaultProps = {
  renderThumb: function renderThumb(props, state) {
    return /*#__PURE__*/_react.default.createElement(_SliderThumb.SliderThumb, (0, _extends2.default)({}, props, {
      "aria-labelledby": props.key
    }), /*#__PURE__*/_react.default.createElement(_SliderLabel.SliderLabel, {
      id: props.key
    }, props['aria-valuetext'] || state.valueNow));
  },
  renderTrack: function renderTrack(props, state) {
    return /*#__PURE__*/_react.default.createElement(_SliderTrack.SliderTrack, (0, _extends2.default)({}, props, {
      trackState: state
    }));
  },
  pearling: true
};